import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { COURSES, CourseDetail } from './Courses';

const COURSE_SEO = {
  '401k': {
    title: 'Free 401(k) Course — How 401k Plans Work | KnowFi',
    desc: 'Learn how 401(k) plans work, contribution limits, employer matching, and how to invest your 401k. Free online course from KnowFi.',
    keywords: '401k course, how does a 401k work, 401k contribution limits, 401k employer match, 401k investing',
  },
  iras: {
    title: 'Free IRA Course — Roth IRA vs Traditional IRA | KnowFi',
    desc: 'Learn the difference between Roth IRA and Traditional IRA, contribution limits, and how to open and invest your IRA. Free from KnowFi.',
    keywords: 'IRA course, Roth IRA vs Traditional IRA, how does an IRA work, IRA contribution limits, open an IRA',
  },
  stocks: {
    title: 'Free Stock Market Course for Beginners | KnowFi',
    desc: 'Learn how the stock market works, how to evaluate stocks, and how to build a portfolio. Free beginner stock market course from KnowFi.',
    keywords: 'stock market course, how to invest in stocks, stock market for beginners, how stocks work, beginner investing',
  },
  crypto: {
    title: 'Free Crypto Course — How Cryptocurrency Works | KnowFi',
    desc: 'Learn how cryptocurrency and blockchain work, how to evaluate crypto assets, and how to invest safely. Free course from KnowFi.',
    keywords: 'crypto course, how does cryptocurrency work, Bitcoin explained, crypto for beginners, blockchain course',
  },
  market: {
    title: 'Free Financial Markets Course | KnowFi',
    desc: 'Learn how financial markets work — bonds, indexes, ETFs, and macroeconomics explained in plain English. Free from KnowFi.',
    keywords: 'financial markets course, how do financial markets work, bonds explained, ETF course, market indexes',
  },
  economy: {
    title: 'Free Economics Course — How the Economy Works | KnowFi',
    desc: 'Learn how the economy works — inflation, interest rates, GDP, and the Fed explained simply. Free course from KnowFi.',
    keywords: 'economics course, how does the economy work, inflation explained, interest rates explained, Federal Reserve',
  },
};

export default function CourseDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const course = COURSES.find(c => c.id === id);

  if (!course) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', color: '#94a3b8', gap: 16 }}>
        <div style={{ fontSize: 48 }}>📚</div>
        <h2 style={{ color: '#f1f5f9', margin: 0 }}>Course not found</h2>
        <Link to="/courses" style={{ color: '#38bdf8', textDecoration: 'none' }}>← All Courses</Link>
      </div>
    );
  }

  const seo = COURSE_SEO[id] || {
    title: `${course.title} | KnowFi Courses`,
    desc: course.tagline || `Learn ${course.title} with KnowFi's free financial education course.`,
    keywords: `${course.title} course, financial education, KnowFi`,
  };

  const tier = localStorage.getItem('knowfi_tier') || 'free';
  const pro = tier === 'pro';

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.desc} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.desc} />
        <link rel="canonical" href={`https://knowfi.io/courses/${id}`} />
      </Helmet>

      <CourseDetail
        course={course}
        onBack={() => navigate('/courses')}
        pro={pro}
      />
    </>
  );
}
